// @flow
import { handleResponse, handleError, handleData } from '@knowledgehound/data/fetchUtils'
import type { ActionT } from '@knowledgehound/data/Action.type'
import type { ErrorT } from '@knowledgehound/data/Error.type'
import queryString from 'query-string'

import type { CardT, NewCardT } from './Card.type'

// CONSTANTS
export const FETCH_CARDS_LOADING = 'FETCH_CARDS_LOADING'
export const FETCH_CARDS_SUCCESS = 'FETCH_CARDS_SUCCESS'
export const FETCH_CARDS_ERROR = 'FETCH_CARDS_ERROR'
export const FETCH_CARD_LOADING = 'FETCH_CARD_LOADING'
export const FETCH_CARD_SUCCESS = 'FETCH_CARD_SUCCESS'
export const FETCH_CARD_ERROR = 'FETCH_CARD_ERROR'
export const CREATE_CARD_LOADING = 'CREATE_CARD_LOADING'
export const CREATE_CARD_SUCCESS = 'CREATE_CARD_SUCCESS'
export const CREATE_CARD_ERROR = 'CREATE_CARD_ERROR'
export const UPDATE_CARD_LOADING = 'UPDATE_CARD_LOADING'
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS'
export const UPDATE_CARD_ERROR = 'UPDATE_CARD_ERROR'
export const DELETE_CARD_LOADING = 'DELETE_CARD_LOADING'
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS'
export const DELETE_CARD_ERROR = 'DELETE_CARD_ERROR'

export function fetchCardsLoading (): ActionT {
  return {
    type: FETCH_CARDS_LOADING
  }
}

export function fetchCardsSuccess (cards: Array<CardT> | string): ActionT {
  return {
    type: FETCH_CARDS_SUCCESS,
    payload: cards
  }
}

export function fetchCardsError (err: ErrorT): ActionT {
  return {
    type: FETCH_CARDS_ERROR,
    error: true,
    payload: err
  }
}

export function fetchCards (storyId: string, params: Object): Function {
  return (dispatch: Function, getState: Function) => {
    dispatch(fetchCardsLoading())

    return new Promise((resolve: Function, reject: Function) => {
      fetch(`/proxy/dalmatian/stories/${storyId}/cards/${params && Object.keys(params).length ? '?' : ''}${queryString.stringify(params)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(handleResponse)
        .then(handleData(resolve, dispatch, fetchCardsSuccess))
        .catch(handleError(reject, dispatch, fetchCardsError))
    })
  }
}

export function fetchCardLoading (): ActionT {
  return {
    type: FETCH_CARD_LOADING
  }
}

export function fetchCardSuccess (card: CardT | string): ActionT {
  return {
    type: FETCH_CARD_SUCCESS,
    payload: card
  }
}

export function fetchCardError (err: ErrorT): ActionT {
  return {
    type: FETCH_CARD_ERROR,
    error: true,
    payload: err
  }
}

export function fetchCard (storyId: string, cardId: string): Function {
  return (dispatch: Function, getState: Function) => {
    dispatch(fetchCardLoading())

    return new Promise((resolve: Function, reject: Function) => {
      fetch(`/proxy/dalmatian/stories/${storyId}/cards/${cardId}/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(handleResponse)
        .then(handleData(resolve, dispatch, fetchCardSuccess))
        .catch(handleError(reject, dispatch, fetchCardError))
    })
  }
}

export function createCardLoading (): ActionT {
  return {
    type: CREATE_CARD_LOADING
  }
}

export function createCardSuccess (card: CardT | string): ActionT {
  return {
    type: CREATE_CARD_SUCCESS,
    payload: card
  }
}

export function createCardError (err: ErrorT): ActionT {
  return {
    type: CREATE_CARD_ERROR,
    error: true,
    payload: err
  }
}

export function createCard (storyId: string, card: NewCardT): Function {
  return (dispatch: Function, getState: Function) => {
    dispatch(createCardLoading())

    return new Promise((resolve: Function, reject: Function) => {
      fetch(`/proxy/dalmatian/stories/${storyId}/cards/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(card),
        credentials: 'same-origin'
      })
        .then(handleResponse)
        .then(handleData(resolve, dispatch, createCardSuccess))
        .catch(handleError(reject, dispatch, createCardError))
    })
  }
}

export function updateCardLoading (): ActionT {
  return {
    type: UPDATE_CARD_LOADING
  }
}

export function updateCardSuccess (card: CardT | string): ActionT {
  return {
    type: UPDATE_CARD_SUCCESS,
    payload: card
  }
}

export function updateCardError (err: ErrorT): ActionT {
  return {
    type: UPDATE_CARD_ERROR,
    error: true,
    payload: err
  }
}

export function updateCard (storyId: string, card: CardT): Function {
  return (dispatch: Function, getState: Function) => {
    dispatch(updateCardLoading())

    return new Promise((resolve: Function, reject: Function) => {
      fetch(`/proxy/dalmatian/stories/${storyId}/cards/${card.id}/`, {
        method: 'PATCH',
        body: JSON.stringify(card),
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'same-origin'
      })
        .then(handleResponse)
        .then(handleData(resolve, dispatch, updateCardSuccess))
        .catch(handleError(reject, dispatch, updateCardError))
    })
  }
}

export function deleteCardLoading (cardId: string): ActionT {
  return {
    type: DELETE_CARD_LOADING,
    payload: {
      id: cardId
    }
  }
}

export function deleteCardSuccess (): ActionT {
  return {
    type: DELETE_CARD_SUCCESS
  }
}

export function deleteCardError (err: ErrorT): ActionT {
  return {
    type: DELETE_CARD_ERROR,
    error: true,
    payload: err
  }
}

export function deleteCard (storyId: string, cardId: string): Function {
  return (dispatch: Function, getState: Function) => {
    dispatch(deleteCardLoading(cardId))

    return new Promise((resolve: Function, reject: Function) => {
      fetch(`/proxy/dalmatian/stories/${storyId}/cards/${cardId}/`, {
        method: 'DELETE',
        credentials: 'same-origin'
      })
        .then(handleResponse)
        .then(handleData(resolve, dispatch, deleteCardSuccess))
        .catch(handleError(reject, dispatch, deleteCardError))
    })
  }
}
